import { AccordionButton, AccordionIcon, AccordionItem, AccordionPanel, Box, Button, Text } from '@chakra-ui/react';
import { createRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

interface ISectionLinksProps {
	customLink: string;
	permanentLink: string;
}

export default function SectionQRCode(props: ISectionLinksProps) {
	const { t } = useTranslation();
	const canvasRef = createRef<HTMLCanvasElement>();
	const linkRef = createRef<HTMLAnchorElement>();

	function handleDownloadClick() {
		const link = document.createElement('a');
		link.download = 'qr-code.png';
		link.href = canvasRef.current?.toDataURL() || '';
		link.click();
	}

	useEffect(() => {
		import('qrcode').then((qrcode) => {
			qrcode.toCanvas(document.getElementById('canvas'), props.permanentLink);
		});
	}, []);

	return (
		<AccordionItem>
			<AccordionButton>
				<Text fontSize="md" fontWeight="500" as="span" flex="1" textAlign="left">
					{t('Share a QR code')}
				</Text>
				<AccordionIcon />
			</AccordionButton>
			<AccordionPanel pb={4} overflow="auto">
				<Box display="grid" justifyContent="center" alignContent="center">
					<canvas ref={canvasRef} id="canvas"></canvas>
					<Button colorScheme="primary" cursor="pointer" onClick={handleDownloadClick}>
						{t('Download')}
					</Button>
				</Box>
			</AccordionPanel>
		</AccordionItem>
	);
}
